export const sizePerPageList = [
  { text: "10", value: 10 },
  { text: "20", value: 20 },
  { text: "50", value: 50 },
];

export const initialFilter = {
  filter: {
    action: "",
    quota_type: "",
  },
  pageNumber: 1,
  pageSize: 10,
};

export const usageLogQuotaType = [
  {
    label: "DONOR",
    value: "DONOR",
  },
  {
    label: "USER",
    value: "USER",
  },
  {
    label: "EMAIL",
    value: "EMAIL",
  },
  {
    label: "SMS",
    value: "SMS",
  },
];

export const usageLogAction = [
  {
    label: "DONOR",
    value: "DONOR",
  },
  {
    label: "USER",
    value: "USER",
  },
  {
    label: "NOTIF",
    value: "NOTIF",
  },
  {
    label: "BROADCAST",
    value: "BROADCAST",
  },
];
